var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14853_144557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14853_144557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33671 14C2.77004 14 2.36727 13.7472 2.12838 13.2417C1.88949 12.7361 1.94782 12.2667 2.30338 11.8333L6.00338 7.33333V3.33333H5.33671C5.14782 3.33333 4.98949 3.26944 4.86171 3.14167C4.73393 3.01389 4.67004 2.85556 4.67004 2.66667C4.67004 2.47778 4.73393 2.31944 4.86171 2.19167C4.98949 2.06389 5.14782 2 5.33671 2H10.67C10.8589 2 11.0173 2.06389 11.145 2.19167C11.2728 2.31944 11.3367 2.47778 11.3367 2.66667C11.3367 2.85556 11.2728 3.01389 11.145 3.14167C11.0173 3.26944 10.8589 3.33333 10.67 3.33333H10.0034V7.33333L13.7034 11.8333C14.0589 12.2667 14.1173 12.7361 13.8784 13.2417C13.6395 13.7472 13.2367 14 12.67 14H3.33671ZM3.33671 12.6667H12.67L8.67004 7.8V3.33333H7.33671V7.8L3.33671 12.6667Z",
    fill: "#74788D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.bbafe1289804fa12b3a660bcc230cb2d.svg";
export { ForwardRef as ReactComponent };